import dayjs from "dayjs";

import { DateFormat, Maybe, Transaction, TransactionQueryResponse } from "@ctypes";
import { convertCentsToDollar, formatCurrency } from "./formatter";

export const calculateNextTransfer = (amountInCents: number, date?: string | null) => {
  const formattedAmount = formatCurrency(convertCentsToDollar(amountInCents), true);

  const formattedDate = date ? dayjs(date).format(DateFormat.FullDate) : null;

  return { amount: formattedAmount, date: formattedDate };
};

export const mergePaginatedTransactions = (
  existing?: TransactionQueryResponse,
  incoming?: TransactionQueryResponse,
) => {
  const existingElements = existing?.elements ?? [];
  const incomingElements = incoming?.elements ?? [];

  const mergedElements = [...existingElements, ...incomingElements];

  const uniqueRefs = new Set<string>();
  const uniqueElements: Array<Maybe<Transaction>> = [];

  mergedElements.forEach((element: any) => {
    if (element?.__ref && !uniqueRefs.has(element.__ref)) {
      uniqueRefs.add(element.__ref);
      uniqueElements.push(element);
    }
  });

  return {
    ...incoming,
    elements: uniqueElements,
  };
};
